import React from 'react';
import ImageCropModal from './ImageCropModal';
import useImageCrop from './useImageCrop';
const ImageCropHelperView = () => {
    const [imageCropState, imageCropActions] = useImageCrop();
    return (React.createElement(ImageCropModal, { ...imageCropState, onClose: imageCropActions.hide, onComplete: imageCropActions.complete }));
};
export default ImageCropHelperView;
